import { Box, Typography } from '@mui/material';
import LawImage1 from 'assets/LawImage1.webp';
import LawImage2 from 'assets/LawImage2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function LawDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Laws" Chunking Method Description</Typography>
      <Typography marginTop={1}>
        Supported file formats are {allowedFilesMap.laws.join(', ')}. Legal documents have a very rigorous writing
        format. We use text feature to detect split point.
      </Typography>
      <Typography marginY={3}>
        The chunk granularity is consistent with 'ARTICLE', and all the upper level text will be included in the chunk.
      </Typography>

      <Typography fontWeight='500' marginTop={3}>
        "Laws" Examples
      </Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={LawImage1} alt='law' width={320} />
        <img src={LawImage2} alt='law' width={320} />
      </Box>
    </Box>
  );
}
